
import {
    SET_AUTHENTICATION,
    REMOVE_AUTHENTICATION
} from '../constants';

import { removeAuthorization } from '../config/axios'
import { removeAuthToken } from '../lib/localStorage'

import {isEmpty} from "../lib/isEmpty";
import {createSocketUser} from '../config/socketConnectivity'

/**
 * Read JWT payload without verifying the signature. API calls must still
 * enforce auth server-side; this is only for client UX (expiry, user id).
 */
const parseJwtPayload = (token) => {
    if (!token || typeof token !== 'string') return null;
    const normalized = token.replace(/^Bearer\s+/i, '');
    const parts = normalized.split('.');
    if (parts.length !== 3) return null;
    try {
        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (err) {
        return null;
    }
};

export const decodeJwt = (token, dispatch) => {
    try {
        if (!isEmpty(token)) {
            const normalized = token.replace(/^Bearer\s+/i, '')
            const payload = parseJwtPayload(normalized);
            if (!payload) {
                throw new Error('Invalid token');
            }
            const userId = payload._id ?? payload.id;
            if (userId) {
                createSocketUser(userId);
                dispatch({
                    type: SET_AUTHENTICATION,
                    authData: {
                        isAuth: true,
                        userId: userId,
                    }
                })
            }
        }
    } catch (err) {
        removeAuthToken()
        removeAuthorization()
        dispatch({
            type: REMOVE_AUTHENTICATION,
            authData: {
                isAuth: false,
            }
        })
    }
}

/**
 * Backend tokens use custom `expiresIn` (ms timestamp) in the payload — see
 * `generateUserToken` in user.controller. Standard JWT `exp` (seconds) may also exist.
 */
export const tokenVerify = (token) => {
    try {
        if (!isEmpty(token)) {
            const payload = parseJwtPayload(
                token.replace(/^Bearer\s+/i, '')
            );
            if (!payload) return false;

            let expiresAtMs = null;
            if (typeof payload.exp === 'number') {
                expiresAtMs = payload.exp * 1000;
            } else if (typeof payload.expiresIn === 'number') {
                expiresAtMs = payload.expiresIn;
            }
            if (expiresAtMs === null) return false;
            if (expiresAtMs <= Date.now()) return false;
            return true;
        }
        return false
    } catch (err) {
        return false
    }
}
